"use client"

import { ZoomEffectButton } from "@/(admin)/components/button/ZoomEffectButton"
import { t } from "@/languages/i18n"
import { postWidgetRegistration } from "@/services/widget-registration-service"
import { useState } from "react"

interface EmailRegistrationFormProps {
    buttonText?: string
    className?: string
}

export const EmailRegistrationForm = ({
    buttonText = t("Register now"),
    className = ""
}: EmailRegistrationFormProps) => {
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState("")
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setEmail(value)
        if (hasAttemptedSubmit && emailError) {
            setEmailError("")
        }
    }

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        setHasAttemptedSubmit(true)

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError(t("Vui lòng nhập email hợp lệ"))
            return
        }

        setEmailError("")
        setIsLoading(true)

        try {
            await postWidgetRegistration({ email })
            setIsSubmitted(true)
        } catch (error) {
            setEmailError(t("Đã xảy ra lỗi khi gửi email. Vui lòng thử lại."))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className={`widget-registration-email w-full ${className}`}>
            <div className="flex gap-0 mb-2 w-full">
                <input
                    type="text"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder={t("Email")}
                    disabled={isLoading}
                    className={`flex-1 pl-[0.875rem] w-full h-[42px] border border-[#CCCCCC] bg-white text-base placeholder:text-[#CCCCCC] placeholder:text-base placeholder:font-normal placeholder:leading-[2.5rem] ${emailError ? "border-red-500" : ""
                        } disabled:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-inset focus:ring-[#18AF4E] focus:border-[#18AF4E]`}
                />
                <ZoomEffectButton
                    text={buttonText}
                    className="w-full rounded-none"
                    onClick={handleSubmit}
                    isInline={true}
                    isLoading={isLoading}
                    loadingText={t("Đang gửi...")}
                />
            </div>
            {emailError && (
                <p className="text-red-500 text-sm mt-1 bg-white px-2 py-1 inline-block shadow-sm">
                    {emailError}
                </p>
            )}
            {isSubmitted && (
                <div className="mt-3 p-3 bg-green-50 border border-green-200 shadow-sm w-full">
                    <p className="text-green-800 font-bold mb-1">{t("Cảm ơn!")}</p>
                    <p className="text-[#333333] text-sm">{t("Thank you for subscribing to our newsletter")}</p>
                </div>
            )}
        </div>
    )
}

